/* eslint-disable import/prefer-default-export */
import { get } from 'lodash';
import { httpClient } from '../../lib/utils';
import { envValue } from '../../config/envUtils';
import { SAVE_LEVEL } from '../constants/Level';
import { Service } from './Service';
import store from '../store/Store';
import * as ActionTypes from '../constants/ActionTypes';

const SOURCEURL = envValue('SOURCEURL');
const SBEM_CLEAR_CACHE_URL = envValue('SBEM_CLEAR_CACHE_URL');

export function clearSbemGlobalConfigCache(chainId, hotelId, saveLevel = SAVE_LEVEL.HOTEL) {
    return httpClient.post(SBEM_CLEAR_CACHE_URL, { chainId, hotelId, saveLevel, keyType: 'globalConfig' });
}

export default class ThirdpartyService extends Service {
    static fetchAllThirdPartyConfigurations(chainId, hotelId = null, saveLevel = SAVE_LEVEL.CHAIN) {
        const urlParams = ThirdpartyService.paramProxy(chainId, hotelId, null, saveLevel);

        return httpClient.get(`${SOURCEURL}/shs-bedesigner-services/v1/contents/thirdparty/all?${urlParams}`);
    }

    static fetchThirdPartyConfig(chainId, hotelId = null, saveLevel = SAVE_LEVEL.CHAIN) {
        const urlParams = ThirdpartyService.paramProxy(chainId, hotelId, null, saveLevel);

        return httpClient
            .get(
                `${SOURCEURL}/shs-bedesigner-services/v1/contents/thirdparty?${urlParams}&explicitlevel=${saveLevel}&foldlevel=${SAVE_LEVEL.CHAIN}`
            )
            .then(foldedResponse => {
                const resultCode = get(foldedResponse, 'data.Result.ResultCode');
                const value = get(foldedResponse, 'data.BEDesignerResult.Value');

                if (resultCode === 'SUCCESS') {
                    const hotelLevelInContextBeta = get(foldedResponse, 'data.BEDesignerResult.Value.Explicit.Data.inContextBeta');
                    if (saveLevel === SAVE_LEVEL.HOTEL && hotelLevelInContextBeta === undefined) {
                        // retrieve explicit chain level inContextBeta if hotel level is not set
                        const chainUrl = `${SOURCEURL}/shs-bedesigner-services/v1/contents/thirdparty?${urlParams}&explicitlevel=chain&foldlevel=${SAVE_LEVEL.CHAIN}`
                        httpClient.get(chainUrl).then(chainResponse => {
                            const chainLevelInContextBeta = get(chainResponse, 'data.BEDesignerResult.Value.Explicit.Data.inContextBeta');
                            store.dispatch({ type: ActionTypes.SET_IN_CONTEXT_BETA, inContextBeta: chainLevelInContextBeta });
                        });
                    } else {
                        store.dispatch({ type: ActionTypes.SET_IN_CONTEXT_BETA, inContextBeta: hotelLevelInContextBeta });
                    }

                    return Promise.resolve({
                        Value: value
                    });
                }

                return Promise.reject(new Error('Cannot retrieve thirdparty configuration at this time'));
            })
            .catch(err => {
                return Promise.reject(new Error(`Cannot retrieve thirdparty configuration at this time, err: ${err}`));
            });
    }

    static saveThirdPartyConfig(chainId, hotelId = null, saveLevel = SAVE_LEVEL.CHAIN, savedData) {
        const urlParams = ThirdpartyService.paramProxy(chainId, hotelId, null, saveLevel);

        return httpClient
            .put(`${SOURCEURL}/shs-bedesigner-services/v1/contents/thirdparty?${urlParams}`, savedData)
            .then(foldedResponse => {
                const resultCode = get(foldedResponse, 'data.Result.ResultCode');

                if (resultCode === 'SUCCESS') {
                    clearSbemGlobalConfigCache(chainId, hotelId, saveLevel);
                    return Promise.resolve();
                }

                return Promise.reject(new Error('Cannot retrieve thirdparty configuration at this time'));
            })
            .catch(err => {
                return Promise.reject(new Error(`Cannot retrieve thirdparty configuration at this time, err: ${err}`));
            });
    }
}



// WEBPACK FOOTER //
// ./src/services/ThirdpartyService.js